import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import store from "../store";

function authService(app) {
  const auth = getAuth(app);
  return {
    logOut: async () => {
      var result = await signOut(auth)
        .then(() => {
          result = true;
          store.commit("setUser", null);
          store.commit("SET_ROLE", "anonymous");
        })
        .catch((error) => {
          console.log(error);
          result = false;
        });
      return result;
    },
    createUserWithEmail: async (email, password) => {
      var result = await createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          store.commit("setUser", user);
          return {
            success: true,
            user: user,
          };
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;

          return {
            error: true,
            code: errorCode,
            message: errorMessage,
          };
        });
      return result;
    },
    signInWithEmail: async (email, password) => {
      var result = await signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;

          return {
            success: true,
            user: user,
          };
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          return {
            error: true,
            code: errorCode,
            message: errorMessage,
          };
        });

      return result;
    },
    onUserAuthChange: async (onChange) => {
      return new Promise((resolve) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            const token = await user.getIdTokenResult(true);
            let role = "anonymous";
            if (token.claims.worker) role = "worker";
            if (token.claims.admin) role = "admin";
            store.commit("setUser", user);
            store.commit("SET_ROLE", role);
          } else {
            store.commit("setUser", null);
            store.commit("SET_ROLE", "anonymous");
          }
          if (onChange) await onChange(user);
          resolve(user);
        });
      });
    },
  };
}

export { authService as default };
